import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Grid, Typography } from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { addEspaceCharacters, instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";

function UnidadAgregar() {
  const [categoria, setCategoria] = React.useState({ Id: "", Nombre: "" });
  const [openDialog, setOpenDialog] = React.useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Categoria",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    instance
      .post("/unidad/", {
        id: user.id,
        nombre: addEspaceCharacters(info.nombre.value),
        categoria: categoria.Id,
      })
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "La unidad ha sido creada exitosamente.",
          redirect: true,
          page: "/CategoriaDetalle",
          pageState: { id: categoria.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Nueva unidad
          </Typography>
          <Grid
            container
            component="form"
            sx={{ mt: 1, display: "flex", flexDirection: "column" }}
            onSubmit={handleSubmit}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <DropDownList
                required
                title="Categoría"
                endpoint={"/categoria/listActive"}
                selectedItem={categoria}
                setSelectedItem={setCategoria}
              />
            </Grid>
            <Grid>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Nombre"
                id="nombre"
                name="nombre"
                autoFocus
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Agregar
            </Button>
          </Grid>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { UnidadAgregar };
